export default __webpack_public_path__ + "static/media/icon.c3f085ce.svg";